import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Myplugin from './plugins/myplugin'
import '@/css/element-variables.scss'
import '@/css/main.scss'
import '@/css/_tokens.scss' // 0819修改
import '@/css/dark-elements.scss' // 0819修改
import echarts from 'echarts'
import '@/icons'
import './permission'
import vPermission from './directives/permission'
import fly from '@/utils/request'
import * as utils from './utils/index'
import * as config from './utils/config'

Vue.use(Myplugin)
Vue.directive('permission', vPermission)
Vue.prototype.$echarts = echarts
Vue.prototype.isProduction = window.location.host.indexOf('eyeqme.com.cn') > -1
Vue.config.productionTip = false
Vue.prototype.$utils = utils
Vue.prototype.$config = config
Vue.prototype.$fly = fly

Vue.use(ElementUI, { size: 'small', zIndex: 3000 })

//页面跳转滚动条归零
router.afterEach(() => {
  window.scrollTo(0, 0);
});

// 0819修改：点击表格外部任意位置，取消所有 el-table 的当前选中行
document.addEventListener('click', (e) => {
  if (e.target.closest('.el-table, .el-popper, .el-dialog, .el-message-box, .el-dropdown-menu')) {
    return;
  }
  document.querySelectorAll('.el-table').forEach((tableEl) => {
    const vm = tableEl.__vue__;
    if (vm && typeof vm.setCurrentRow === 'function') {
      vm.setCurrentRow();
    }
  });
});

// 0819修改：主题切换后重新计算所有 el-table 布局，避免固定列残留黑色/宽度不一致
function relayoutAllTables() {
  setTimeout(() => {
    document.querySelectorAll('.el-table').forEach((tableEl) => {
      const vm = tableEl.__vue__;
      if (vm && typeof vm.doLayout === 'function') {
        vm.doLayout();
      }
    });
  }, 50);
}
window.addEventListener('theme-change', relayoutAllTables);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
